var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{class:_vm.item.classes,domProps:{"innerHTML":_vm._s(_vm.item.html)}})
}
var staticRenderFns = []

export { render, staticRenderFns }